import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWrapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TEXT from "../../../../utils/globalText";

const ScheduleInternalTransactionFailed = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { scheduledInternalCreateError } = useSelector(
    (state) => state.scheduleInternalTransactions,
  );

  useEffect(() => {
    dispatch(disableSwitcher());
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const errorData =
    scheduledInternalCreateError?.response?.data ||
    scheduledInternalCreateError ||
    {};

  const errorMessages = Object.values(errorData?.errors || {}).flatMap(
    (messages) => (Array.isArray(messages) ? messages : [messages]),
  );

  const buttonRows = [
    [
      {
        btnText: "Create schedule",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        imgColor: "var(--negative-bg)",
        handleFunction: () =>
          navigate(
            "/internal_transaction_dashboard/create_schedule_transaction",
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/internal_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      title={TEXT?.SCHEDULE_CREATION_FAILED}
      buttonRows={buttonRows}
    >
      <TabsWrapperSection title="Error details">
        <div className="flex flex-col">
          {errorMessages.length > 0 &&
            errorMessages.map((msg, index) => (
              <InfoCard
                key={index}
                bgColor="var(--negative-card)"
                rows={[
                  {
                    leftTitle: msg,
                    leftSubTitle: TEXT?.ERROR_MESSAGE,
                  },
                ]}
              />
            ))}
        </div>
      </TabsWrapperSection>
    </StatusContainer>
  );
};

export default ScheduleInternalTransactionFailed;
